module.exports = __webpack_public_path__ + "media/images/ns-splashscreen-2021-side-4b9ad1d3fd0977ec6e9429090756fe4e.jpg";